/**
 * @generated SignedSource<<a555392f18b710a8a4e9a3155a549383>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RevokeAddedClientInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type ClientPendingMenuDeleteMutation$variables = {
  input: RevokeAddedClientInput;
};
export type ClientPendingMenuDeleteMutation$data = {
  readonly revokeAddedClient: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type ClientPendingMenuDeleteMutation = {
  response: ClientPendingMenuDeleteMutation$data;
  variables: ClientPendingMenuDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RevokeAddedClientPayload",
    "kind": "LinkedField",
    "name": "revokeAddedClient",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientPendingMenuDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientPendingMenuDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f8a92853f79d0767cd0a054ee02b4a06",
    "id": null,
    "metadata": {},
    "name": "ClientPendingMenuDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ClientPendingMenuDeleteMutation(\n  $input: RevokeAddedClientInput!\n) {\n  revokeAddedClient(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "86b2faf75ed045a81efec8aa9af24086";

export default node;
